export const SearchBar = {
  extends: ['DropdownParentFocus'],
  position: 'relative',
  theme: 'quinary',
  round: 'radiusPill',
  // `minWidth` on a letter token is a HARD floor: the component can never
  // shrink below it, so it overflows any container narrower than that — a
  // catalog cell, a narrow split pane. The intent is a PREFERRED width,
  // which is `width` + `maxWidth: '100%'`: same size when there's room,
  // shrinks instead of overflowing when there isn't (see brand DropdownField
  // for the canonical version of this fix).
  width: 'D3',
  maxWidth: '100%',
  margin: '-V - - -',
  tag: 'search',
  state: {
    recents: []
  },
  Input_trigger: null,
  Form: {
    flow: 'x',
    align: 'center',
    gap: 'X',
    onSubmit: (ev) => ev.preventDefault(),
    Icon: {
      fontSize: 'Z1',
      margin: '- -B2 - A',
      name: 'search'
    },
    Input: {
      round: '0',
      placeholder: (el) => el.call('polyglot', 'shell.searchBar.placeholder'),
      padding: 'Y1 B2 Y1 C',
      theme: 'transparent',
      // A typed value takes the brand value ink; the transparent theme's own
      // ink is a 65% alpha, one tone with the placeholder hint in light.
      color: 'title',
      outline: 'none',
      appearance: 'none',
      // Native <input> has its own intrinsic min-content floor that
      // `flex: 1` alone doesn't override — same class as the root's
      // minWidth fix above, just living on the child this time.
      minWidth: '0',
      ':focus-visible': {
        outline: 'none'
      },
      '::-webkit-search-cancel-button': {
        display: 'none'
      },
      '::placeholder': {
        color: 'placeholder'
      },
      onInput: (ev, el, s) => {
        s.update({
          searchTerm: el.node.value
        })
      },
      flex: 1
    }
  },
  Dropdown: {
    top: '105%',
    width: '100%',
    left: '0',
    // Wrapper first, menu body LAST — the §7.7 MenuPanel surface must win the
    // merge over the brand Dropdown's legacy common-box chrome.
    extends: ['Dropdown', 'CanvasSearchDropdown']
  }
}
